var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.chipColor(_vm.data.status)}},[_c('span',[_vm._v(_vm._s(_vm.toUpperCase(_vm.data.status)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }